var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import SelectMUI from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { IconVariant } from './types';
import styles from './select.module.css';
import { Plus } from '@otp/icons';
const optionIcon = {
    [IconVariant.AddIcon]: _jsx(Plus, {}),
    [IconVariant.RemoveIcon]: _jsx(Plus, {}),
};
export const Select = (props) => {
    const { options, children, defaultValue, displayEmpty, onChange } = props, rest = __rest(props, ["options", "children", "defaultValue", "displayEmpty", "onChange"]);
    const [selectedValue, setSelectedValue] = useState(defaultValue || '');
    useEffect(() => {
        setSelectedValue(defaultValue || '');
    }, [defaultValue]);
    const selectedOption = useMemo(() => {
        return options === null || options === void 0 ? void 0 : options.find((option) => option.value === selectedValue);
    }, [options, selectedValue]);
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event, undefined);
    };
    const renderValue = () => {
        if (!selectedOption && displayEmpty) {
            return _jsx("em", { children: "None" });
        }
        return _jsx(_Fragment, { children: selectedOption && selectedOption.name });
    };
    const optionComponents = useMemo(() => {
        if (children) {
            return children;
        }
        const optionItems = (options || []).map(({ name, value, iconVariant, extra }) => (_jsxs(MenuItem, { className: styles.option, value: value, "data-testid": "option", children: [name, _jsxs("div", { className: styles.extra, children: [extra, iconVariant && optionIcon[iconVariant]] })] }, name)));
        if (displayEmpty) {
            optionItems.unshift(_jsx(MenuItem, { value: undefined, "data-testid": "empty-option", children: _jsx("em", { children: "None" }) }, "empty"));
        }
        return optionItems;
    }, [options, children]);
    return (_jsx(SelectMUI, Object.assign({ value: selectedValue, onChange: handleChange, renderValue: renderValue, displayEmpty: displayEmpty, defaultValue: defaultValue }, rest, { children: optionComponents })));
};
export default Select;
